import React from 'react';
import { Icon } from '../Icon/Icon.js';
import './Checkbox.css';

export const Checkbox = ({
  checked = false,
  onChange,
  disabled = false,
  label,
  className = '',
  ...props
}) => {
  const baseClass = 'checkbox';
  const checkedClass = checked ? 'checkbox--checked' : '';
  const disabledClass = disabled ? 'checkbox--disabled' : '';

  const combinedClassName = [
    baseClass,
    checkedClass,
    disabledClass,
    className
  ].filter(Boolean).join(' ');

  const handleChange = (e) => {
    if (!disabled && onChange) {
      onChange(e.target.checked);
    }
  };

  const handleKeyDown = (e) => {
    if (!disabled && (e.key === ' ' || e.key === 'Enter')) {
      e.preventDefault();
      if (onChange) {
        onChange(!checked);
      }
    }
  };

  return (
    <label className="checkbox-wrapper" tabIndex={-1}>
      <input
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        className="checkbox__input"
        tabIndex={-1}
        {...props}
      />
      <div
        className={combinedClassName}
        tabIndex={disabled ? -1 : 0}
        onKeyDown={handleKeyDown}
        role="checkbox"
        aria-checked={checked}
        aria-disabled={disabled}
      >
        {checked && (
          <Icon name="check" size="small" className="checkbox__icon" />
        )}
      </div>
      {label && (
        <span className="checkbox__label">{label}</span>
      )}
    </label>
  );
};
